<template>
  <div class="ejecucion-root" data-aos="fade-right">
    <!-- ══ VISTA TABLA ══ -->
    <template v-if="!rutinaActiva">
      <CrudToolbar
        title="Mtto. Preventivo"
        v-model="filtroTexto"
        searchPlaceholder="Buscar máquina o rutina..."
      >
        <template #extra>
          <button
            class="chip-toggle"
            :class="{ activo: store.mostrarCompletados }"
            @click="store.toggleCompletados()"
          >
            <i :class="store.mostrarCompletados ? 'bi bi-eye-fill' : 'bi bi-eye-slash'"></i>
            Ver completadas
          </button>
          <button v-if="hayFiltros" class="btn-limpiar" @click="limpiarFiltros">
            <i class="bi bi-x-lg me-1"></i>Limpiar
          </button>
        </template>
        <template #actions>
          <button
            class="btn-refrescar btn-header"
            @click="cargar"
            :disabled="store.cargandoLista"
            title="Actualizar"
          >
            <i class="bi bi-arrow-clockwise"></i>
          </button>
        </template>
      </CrudToolbar>

      <!-- Tabla -->
      <div class="tabla-wrapper">
        <div v-if="store.cargandoLista" class="estado-tabla">
          <div class="spinner-border text-verde"></div>
          <p class="mt-2 text-cafe small mb-0">Cargando rutinas...</p>
        </div>

        <div v-else-if="rutinasOrdenadas.length === 0" class="estado-tabla">
          <i
            class="bi bi-calendar-x"
            style="font-size: 2.5rem; opacity: 0.2; color: var(--d-green)"
          ></i>
          <p class="mt-2 text-cafe small mb-0 opacity-50">Sin rutinas para mostrar</p>
        </div>

        <template v-else>
          <!-- ══ TABLA ESCRITORIO ══ -->
          <div class="d-none d-lg-block">
          <table class="tabla-rutinas">
            <thead>
              <tr>
                <th>
                  <ColumnFilterMenu
                    field="estatus_label"
                    label="Estatus"
                    :items="calendariosParaFiltro"
                    :sortField="sortKey"
                    :sortAsc="sortDir === 'asc'"
                    :modelValue="filtroEstatusSet"
                    @update:modelValue="filtroEstatusSet = $event"
                    @update:sort="onSort"
                  />
                </th>
                <th>
                  <ColumnFilterMenu
                    field="maquina_nombre"
                    label="Máquina"
                    :items="calendariosParaFiltro"
                    :sortField="sortKey"
                    :sortAsc="sortDir === 'asc'"
                    :modelValue="filtroMaquinaSet"
                    @update:modelValue="filtroMaquinaSet = $event"
                    @update:sort="onSort"
                  />
                </th>
                <th>
                  <ColumnFilterMenu
                    field="rutina_nombre"
                    label="Rutina"
                    :filterable="false"
                    :items="calendariosFiltradosCol"
                    :sortField="sortKey"
                    :sortAsc="sortDir === 'asc'"
                    @update:sort="onSort"
                  />
                </th>
                <th>
                  <ColumnFilterMenu
                    field="rutina_area"
                    label="Área"
                    :items="calendariosParaFiltro"
                    :sortField="sortKey"
                    :sortAsc="sortDir === 'asc'"
                    :modelValue="filtroAreaSet"
                    @update:modelValue="filtroAreaSet = $event"
                    @update:sort="onSort"
                  />
                </th>
                <th>
                  <ColumnFilterMenu
                    field="periodicidad_label"
                    label="Periodicidad"
                    :items="calendariosParaFiltro"
                    :sortField="sortKey"
                    :sortAsc="sortDir === 'asc'"
                    :modelValue="filtroPeriodicidadSet"
                    @update:modelValue="filtroPeriodicidadSet = $event"
                    @update:sort="onSort"
                  />
                </th>
                <th>
                  <ColumnFilterMenu
                    field="fecha_programada"
                    label="Programado"
                    type="date"
                    :filterable="false"
                    :items="calendariosFiltradosCol"
                    :sortField="sortKey"
                    :sortAsc="sortDir === 'asc'"
                    @update:sort="onSort"
                  />
                </th>
                <th>
                  <ColumnFilterMenu
                    field="fecha_limite"
                    label="Límite"
                    type="date"
                    :filterable="false"
                    :items="calendariosFiltradosCol"
                    :sortField="sortKey"
                    :sortAsc="sortDir === 'asc'"
                    @update:sort="onSort"
                  />
                </th>
                <th>Progreso</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="cal in rutinasPaginadas"
                :key="cal.id"
                class="fila-rutina"
                @click="seleccionar(cal)"
              >
                <td>
                  <span :class="['badge-est', clsEst(cal.estatus)]">
                    <span
                      class="dot-sm"
                      :style="{ background: colorEst(cal.estatus) }"
                    ></span>
                    {{ labelEst(cal.estatus) }}
                  </span>
                </td>
                <td>
                  <span class="cell-maquina">{{ cal.maquina_nombre || "—" }}</span>
                </td>
                <td>
                  <span class="cell-rutina">{{ cal.rutina_nombre || "—" }}</span>
                </td>
                <td>
                  <span v-if="cal.rutina_area" class="badge-area">
                    {{ cal.rutina_area }}
                  </span>
                  <span v-else class="text-muted small">—</span>
                </td>
                <td>
                  <span v-if="cal.rutina_periodicidad" class="badge-periodicidad">
                    {{ labelPeriodicidad(cal.rutina_periodicidad) }}
                  </span>
                  <span v-else class="text-muted small">—</span>
                </td>
                <td class="cell-fecha">{{ formatFecha(cal.fecha_programada) }}</td>
                <td class="cell-fecha">
                  <span :class="{ 'text-danger fw-bold': estaAtrasado(cal) }">{{
                    formatFecha(cal.fecha_limite)
                  }}</span>
                </td>
                <td class="cell-progreso">
                  <div v-if="cal.actividades?.length" class="progreso-mini">
                    <div class="progreso-mini-bar">
                      <div
                        class="progreso-mini-fill"
                        :style="{ width: pctActividades(cal) + '%' }"
                      ></div>
                    </div>
                    <span class="progreso-mini-texto"
                      >{{ actCompletadas(cal) }}/{{ cal.actividades.length }}</span
                    >
                  </div>
                  <span v-else class="text-muted small">—</span>
                </td>
                <td class="cell-accion">
                  <span class="btn-ver"><i class="bi bi-chevron-right"></i></span>
                </td>
              </tr>
            </tbody>
          </table>
          </div>

          <!-- ══ CARDS MÓVIL ══ -->
          <div class="d-lg-none">
            <div
              v-for="cal in rutinasPaginadas"
              :key="'mob-' + cal.id"
              class="divisan-mobile-card mb-3 p-3 shadow-sm"
              :style="{ borderLeftColor: colorEst(cal.estatus) }"
              @click="seleccionar(cal)"
            >
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div>
                  <span class="cell-maquina d-block">{{ cal.maquina_nombre || "—" }}</span>
                  <span class="cell-rutina">{{ cal.rutina_nombre || "—" }}</span>
                </div>
                <span :class="['badge-est', clsEst(cal.estatus)]">
                  <span class="dot-sm" :style="{ background: colorEst(cal.estatus) }"></span>
                  {{ labelEst(cal.estatus) }}
                </span>
              </div>

              <div class="d-flex flex-wrap gap-2 mb-2">
                <span v-if="cal.rutina_area" class="badge-area">{{ cal.rutina_area }}</span>
                <span v-if="cal.rutina_periodicidad" class="badge-periodicidad">
                  {{ labelPeriodicidad(cal.rutina_periodicidad) }}
                </span>
              </div>

              <div class="d-flex justify-content-between align-items-center mb-2">
                <small class="text-cafe opacity-70"
                  >Prog: {{ formatFecha(cal.fecha_programada) }}</small
                >
                <small :class="{ 'text-danger fw-bold': estaAtrasado(cal) }">
                  Límite: {{ formatFecha(cal.fecha_limite) }}
                </small>
              </div>

              <div v-if="cal.actividades?.length" class="progreso-mini">
                <div class="progreso-mini-bar">
                  <div
                    class="progreso-mini-fill"
                    :style="{ width: pctActividades(cal) + '%' }"
                  ></div>
                </div>
                <span class="progreso-mini-texto"
                  >{{ actCompletadas(cal) }}/{{ cal.actividades.length }}</span
                >
              </div>

              <div class="d-flex justify-content-end pt-2 border-top mt-2">
                <span class="btn-ver"><i class="bi bi-chevron-right"></i></span>
              </div>
            </div>
          </div>

          <!-- Paginación -->
          <div class="paginacion-wrapper">
            <div class="pag-izq">
              <small class="pag-info">
                {{ rangoInicio }}–{{ rangoFin }} de {{ rutinasOrdenadas.length }} rutinas
              </small>
              <div class="por-pagina-wrap">
                <label class="por-pagina-label">Filas:</label>
                <select
                  class="por-pagina-select"
                  :value="porPagina"
                  @change="cambiarPorPagina(Number($event.target.value))"
                >
                  <option v-for="n in opcionesPorPagina" :key="n" :value="n">
                    {{ n }}
                  </option>
                </select>
              </div>
            </div>

            <div class="contadores-inline">
              <span class="chip-contador total">
                <i class="bi bi-list-check"></i>
                <strong>{{ rutinasOrdenadas.length }}</strong> rutinas
              </span>
              <span class="chip-contador pendiente">
                <i class="bi bi-hourglass-split"></i>
                <strong>{{ conteoPendientes }}</strong> pendientes
              </span>
            </div>

            <div class="pag-der">
              <button
                class="btn-pag"
                :disabled="paginaActual === 1"
                @click="paginaActual = 1"
                title="Primera"
              >
                <i class="bi bi-chevron-double-left"></i>
              </button>
              <button
                class="btn-pag"
                :disabled="paginaActual === 1"
                @click="paginaActual--"
              >
                <i class="bi bi-chevron-left"></i>
              </button>

              <template v-for="p in paginasVisibles" :key="p">
                <span v-if="p === '...'" class="pag-ellipsis">…</span>
                <button
                  v-else
                  :class="['btn-pag-num', { activo: p === paginaActual }]"
                  @click="paginaActual = p"
                >
                  {{ p }}
                </button>
              </template>

              <button
                class="btn-pag"
                :disabled="paginaActual === totalPaginas"
                @click="paginaActual++"
              >
                <i class="bi bi-chevron-right"></i>
              </button>
              <button
                class="btn-pag"
                :disabled="paginaActual === totalPaginas"
                @click="paginaActual = totalPaginas"
                title="Última"
              >
                <i class="bi bi-chevron-double-right"></i>
              </button>
            </div>
          </div>
        </template>
      </div>
    </template>

    <!-- ══ VISTA DETALLE ══ -->
    <template v-else>
      <div class="detalle-navbar mb-3">
        <button class="btn-volver" @click="volver">
          <i class="bi bi-arrow-left me-2"></i>Regresar a rutinas
        </button>
        <div class="breadcrumb-detalle">
          <span class="bc-maquina">{{ store.calendarioActivo?.maquina_nombre }}</span>
          <i class="bi bi-chevron-right bc-sep"></i>
          <span class="bc-rutina">{{ store.calendarioActivo?.rutina_nombre }}</span>
        </div>
      </div>

      <PanelDetalleEjecucion
        @abrir-finalizar="modalFinalizar?.abrir()"
        @finalizado="onFinalizado"
      />
    </template>

    <ModalFinalizarEjecucion ref="modalFinalizar" @finalizado="onFinalizado" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useEjecucionStore } from "@/store/ejecucionStore";
import Swal from "sweetalert2";
import CrudToolbar from "@/components/Shared/CrudToolbar.vue";
import ColumnFilterMenu from "@/components/Shared/ColumnFilterMenu.vue";

import PanelDetalleEjecucion from "./Ejecucion/PanelDetalleEjecucion.vue";
import ModalFinalizarEjecucion from "./Ejecucion/ModalFinalizarEjecucion.vue";

const store = useEjecucionStore();
const modalFinalizar = ref(null);
const rutinaActiva = ref(false);

// El buscador del toolbar necesita v-model; el texto vive en el store.
const filtroTexto = computed({
  get: () => store.filtroTexto,
  set: (v) => store.setFiltroTexto(v),
});

// ── Filtros de columna (embudo) ─────────────────────────────────
const filtroMaquinaSet = ref(new Set());
const filtroAreaSet = ref(new Set());
const filtroPeriodicidadSet = ref(new Set());
const filtroEstatusSet = ref(new Set());

const hayFiltros = computed(
  () =>
    store.filtroTexto ||
    filtroMaquinaSet.value.size ||
    filtroAreaSet.value.size ||
    filtroPeriodicidadSet.value.size ||
    filtroEstatusSet.value.size
);

function limpiarFiltros() {
  store.limpiarFiltros();
  filtroMaquinaSet.value = new Set();
  filtroAreaSet.value = new Set();
  filtroPeriodicidadSet.value = new Set();
  filtroEstatusSet.value = new Set();
  paginaActual.value = 1;
}

watch(
  () => store.filtroTexto,
  () => {
    paginaActual.value = 1;
  }
);
watch(
  () => store.mostrarCompletados,
  () => {
    paginaActual.value = 1;
  }
);
watch([filtroMaquinaSet, filtroAreaSet, filtroPeriodicidadSet, filtroEstatusSet], () => {
  paginaActual.value = 1;
});

// ── Filtro de columna + "ver completadas" ───────────────────────
// calendariosFiltrados (store) ya aplica el texto de búsqueda.
const calendariosParaFiltro = computed(() =>
  store.calendariosFiltrados.map((c) => ({
    ...c,
    periodicidad_label: labelPeriodicidad(c.rutina_periodicidad),
    estatus_label: labelEst(c.estatus),
  }))
);

const calendariosFiltradosCol = computed(() => {
  // Si el usuario pide explícitamente "Completado" en el embudo de Estatus,
  // ese filtro manda sobre el toggle "ver completadas" — antes se
  // contradecían y la búsqueda de completados quedaba siempre vacía.
  const completadoExplicito = filtroEstatusSet.value.has("Completado");
  return calendariosParaFiltro.value.filter((c) => {
    const matchMaquina =
      !filtroMaquinaSet.value.size || filtroMaquinaSet.value.has(c.maquina_nombre);
    const matchArea = !filtroAreaSet.value.size || filtroAreaSet.value.has(c.rutina_area);
    const matchPeriodicidad =
      !filtroPeriodicidadSet.value.size ||
      filtroPeriodicidadSet.value.has(c.periodicidad_label);
    const matchEstatus =
      !filtroEstatusSet.value.size || filtroEstatusSet.value.has(c.estatus_label);
    const matchCompletado =
      store.mostrarCompletados || completadoExplicito ? true : c.estatus !== "COMPLETADO";
    return matchMaquina && matchArea && matchPeriodicidad && matchEstatus && matchCompletado;
  });
});

// ── Contadores (total + pendientes, mostrados junto a la paginación) ──
const conteoPendientes = computed(
  () => calendariosFiltradosCol.value.filter((c) => c.estatus === "PENDIENTE").length
);

// ── Ordenamiento ──────────────────────────────────────────────
const sortKey = ref("");
const sortDir = ref("asc");

function onSort({ field, asc }) {
  sortKey.value = field;
  sortDir.value = asc ? "asc" : "desc";
  paginaActual.value = 1;
}

const rutinasOrdenadas = computed(() => {
  const base = calendariosFiltradosCol.value;
  if (!sortKey.value) return base;
  return [...base].sort((a, b) => {
    let va = a[sortKey.value] ?? "";
    let vb = b[sortKey.value] ?? "";
    const cmp = String(va).localeCompare(String(vb), "es", { sensitivity: "base" });
    return sortDir.value === "asc" ? cmp : -cmp;
  });
});

// ── Paginación ────────────────────────────────────────────────
const paginaActual = ref(1);
const porPagina = ref(5);
const opcionesPorPagina = [5, 10, 25, 50];

const totalPaginas = computed(() =>
  Math.max(1, Math.ceil(rutinasOrdenadas.value.length / porPagina.value))
);

const rutinasPaginadas = computed(() => {
  const ini = (paginaActual.value - 1) * porPagina.value;
  return rutinasOrdenadas.value.slice(ini, ini + porPagina.value);
});

const rangoInicio = computed(() =>
  rutinasOrdenadas.value.length === 0 ? 0 : (paginaActual.value - 1) * porPagina.value + 1
);
const rangoFin = computed(() =>
  Math.min(paginaActual.value * porPagina.value, rutinasOrdenadas.value.length)
);

function cambiarPorPagina(n) {
  porPagina.value = n;
  paginaActual.value = 1;
}

const paginasVisibles = computed(() => {
  const total = totalPaginas.value;
  const actual = paginaActual.value;
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const set = new Set([1, total, actual]);
  if (actual > 1) set.add(actual - 1);
  if (actual < total) set.add(actual + 1);
  const ordenadas = [...set].sort((a, b) => a - b);
  const resultado = [];
  for (let i = 0; i < ordenadas.length; i++) {
    if (i > 0 && ordenadas[i] - ordenadas[i - 1] > 1) resultado.push("...");
    resultado.push(ordenadas[i]);
  }
  return resultado;
});

// ── Selección ─────────────────────────────────────────────────
async function seleccionar(cal) {
  await store.seleccionarCalendario(cal);
  rutinaActiva.value = true;
}
function volver() {
  rutinaActiva.value = false;
  store.calendarioActivo = null;
  store.ejecucion = null;
}
async function onFinalizado() {
  await cargar();
  volver();
}

// ── Carga ─────────────────────────────────────────────────────
async function cargar() {
  try {
    await store.cargarCalendarios("preventivo");
    paginaActual.value = 1;
  } catch {
    Swal.fire({
      icon: "error",
      title: "Error de conexión",
      text: "No se pudieron cargar las rutinas.",
      confirmButtonColor: "var(--d-brown)",
    });
  }
}

onMounted(async () => {
  await cargar();
});

// ── Helpers ───────────────────────────────────────────────────
const LABEL_ESTATUS = {
  PENDIENTE: "Pendiente",
  EN_PROCESO: "En proceso",
  COMPLETADO: "Completado",
  ATRASADO: "Atrasado",
};
const COLOR_ESTATUS = {
  PENDIENTE: "#d48804",
  EN_PROCESO: "#1565c0",
  COMPLETADO: "var(--d-green)",
  ATRASADO: "#cc3636",
};
const LABEL_PERIODICIDAD = {
  SEMANAL: "Semanal",
  MENSUAL: "Mensual",
  TRIMESTRAL: "Trimestral",
  SEMESTRAL: "Semestral",
  ANUAL: "Anual",
};

const labelEst = (v) => LABEL_ESTATUS[v] || v || "—";
const colorEst = (v) => COLOR_ESTATUS[v] || "#888";
const clsEst = (v) => (v || "").toLowerCase().replace("_", "-");
const labelPeriodicidad = (v) => LABEL_PERIODICIDAD[v] || v || "—";

function formatFecha(f) {
  if (!f) return "—";
  return new Date(f + "T12:00:00").toLocaleDateString("es-MX", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
function estaAtrasado(cal) {
  if (!cal.fecha_limite) return false;
  return new Date() > new Date(cal.fecha_limite + "T23:59:59");
}
function actCompletadas(cal) {
  return (cal.actividades || []).filter((a) => a.completado).length;
}
function pctActividades(cal) {
  const total = cal.actividades?.length || 0;
  return total ? Math.round((actCompletadas(cal) / total) * 100) : 0;
}
</script>

<style scoped>
.ejecucion-root {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Toolbar extras */
.btn-refrescar {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--d-nav-hover-bg);
  color: var(--d-brown);
  cursor: pointer;
  transition: background 0.2s ease;
}
.btn-refrescar:hover:not(:disabled) {
  background: var(--d-green);
  color: var(--d-cream);
}
.btn-refrescar:disabled {
  opacity: 0.4;
  cursor: default;
}

.chip-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: 1.5px solid var(--d-border-soft);
  border-radius: var(--d-radius-pill);
  background: var(--d-field-soft);
  color: var(--d-text-muted);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.chip-toggle:hover {
  border-color: var(--d-green);
}
.chip-toggle.activo {
  background: var(--d-green);
  border-color: var(--d-green);
  color: var(--d-cream);
}

.btn-limpiar {
  display: inline-flex;
  align-items: center;
  height: 32px;
  background: none;
  border: 1px dashed rgba(64, 34, 8, 0.3);
  color: var(--d-brown);
  border-radius: var(--d-radius-pill);
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0 10px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.18s;
  white-space: nowrap;
}
.btn-limpiar:hover {
  opacity: 1;
  background: rgba(64, 34, 8, 0.05);
}

/* Tabla */
.tabla-wrapper {
  background: var(--d-cream);
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  flex: 1;
}
.estado-tabla {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 1rem;
  color: var(--d-green);
}
.text-cafe {
  color: var(--d-brown);
}
.text-verde {
  color: var(--d-green);
}

.tabla-rutinas {
  width: 100%;
  border-collapse: collapse;
}
.tabla-rutinas thead tr {
  background: rgba(96, 108, 56, 0.08);
  border-bottom: 2px solid rgba(96, 108, 56, 0.15);
}
.tabla-rutinas th {
  padding: 10px 14px;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--d-green);
  white-space: nowrap;
  text-align: left;
}
.tabla-rutinas tbody tr {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
}
.tabla-rutinas tbody tr:last-child {
  border-bottom: none;
}
.tabla-rutinas td {
  padding: 10px 14px;
  vertical-align: middle;
}

.fila-rutina {
  cursor: pointer;
  transition: background 0.15s;
}
.fila-rutina:hover {
  background: rgba(96, 108, 56, 0.06);
}

/* Celdas */
.cell-maquina {
  font-size: 0.87rem;
  font-weight: 800;
  color: var(--d-brown);
}
.cell-rutina {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--d-green);
}
.cell-fecha {
  font-size: 0.8rem;
  color: var(--d-brown);
  opacity: 0.75;
  white-space: nowrap;
}
.cell-accion {
  text-align: right;
  width: 36px;
}
.btn-ver {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: var(--d-green);
  font-size: 0.75rem;
  transition: all 0.15s;
}
.fila-rutina:hover .btn-ver {
  background: var(--d-green);
  color: var(--d-cream);
}

/* Badges estatus */
.badge-est {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 20px;
  white-space: nowrap;
}
.dot-sm {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}
.badge-est.pendiente {
  background: #fff3cd;
  color: #7a5a00;
}
.badge-est.en-proceso {
  background: #cfe2ff;
  color: #1565c0;
}
.badge-est.completado {
  background: #d1e7dd;
  color: #0f5132;
}
.badge-est.atrasado {
  background: #f8d7da;
  color: #842029;
}

/* Badges área y periodicidad */
.badge-area {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 12px;
  font-size: 0.72rem;
  font-weight: 800;
  background: rgba(96, 108, 56, 0.12);
  color: var(--d-green-dark);
  border: 1px solid rgba(96, 108, 56, 0.2);
}
.badge-periodicidad {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 12px;
  font-size: 0.72rem;
  font-weight: 800;
  background: rgba(64, 34, 8, 0.09);
  color: var(--d-brown);
  border: 1px solid rgba(64, 34, 8, 0.15);
}

/* Progreso mini */
.cell-progreso {
  min-width: 110px;
}
.progreso-mini {
  display: flex;
  align-items: center;
  gap: 6px;
}
.progreso-mini-bar {
  flex: 1;
  height: 6px;
  background: rgba(96, 108, 56, 0.15);
  border-radius: 4px;
  overflow: hidden;
}
.progreso-mini-fill {
  height: 100%;
  background: var(--d-green);
  border-radius: 4px;
  transition: width 0.3s;
}
.progreso-mini-texto {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}

/* ── Paginación ── */
/* Grid de 3 columnas para poder centrar los contadores en el mismo
   renglón que el rango/selector de filas (izquierda) y los botones de
   página (derecha), sin que se estorben entre sí. */
.paginacion-wrapper {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 10px 16px;
  gap: 10px;
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background: rgba(96, 108, 56, 0.05);
}
.pag-izq {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.contadores-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  gap: 6px;
  flex-wrap: wrap;
}
.chip-contador {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.15);
  color: var(--d-brown);
  white-space: nowrap;
}
.chip-contador.pendiente {
  border-color: rgba(212, 136, 4, 0.3);
  color: #7a5a00;
}
.pag-der {
  display: flex;
  align-items: center;
  justify-self: end;
  gap: 4px;
}
.pag-info {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-brown);
  white-space: nowrap;
}

/* Select por página personalizado */
.por-pagina-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.por-pagina-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-select {
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23606c38' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 8px center;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  padding: 3px 26px 3px 10px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--d-brown);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
  min-width: 58px;
}
.por-pagina-select:focus,
.por-pagina-select:hover {
  border-color: var(--d-brown);
}

/* Botones de navegación */
.btn-pag {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.35);
  color: var(--d-brown);
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.8rem;
}
.btn-pag:hover:not(:disabled) {
  background: var(--d-green);
  color: var(--d-cream);
  border-color: var(--d-green);
}
.btn-pag:disabled {
  opacity: 0.3;
  cursor: default;
}

.btn-pag-num {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.25);
  color: var(--d-brown);
  border-radius: 8px;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.82rem;
  font-weight: 700;
}
.btn-pag-num:hover {
  background: rgba(96, 108, 56, 0.1);
  border-color: var(--d-green);
}
.btn-pag-num.activo {
  background: var(--d-brown);
  color: var(--d-cream);
  border-color: var(--d-brown);
  pointer-events: none;
}

.pag-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 32px;
  font-size: 0.85rem;
  color: var(--d-brown);
  opacity: 0.4;
  font-weight: 700;
}

/* Vista detalle */
.detalle-navbar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.btn-volver {
  display: inline-flex;
  align-items: center;
  background: rgba(254, 250, 224, 0.18);
  border: 1px solid rgba(254, 250, 224, 0.35);
  color: var(--d-cream);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 0.83rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}
.btn-volver:hover {
  background: rgba(254, 250, 224, 0.28);
}
.breadcrumb-detalle {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
}
.bc-maquina {
  font-size: 0.9rem;
  font-weight: 800;
  color: var(--d-cream);
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bc-sep {
  color: var(--d-cream);
  opacity: 0.4;
  font-size: 0.75rem;
  flex-shrink: 0;
}
.bc-rutina {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--d-cream);
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Cards móvil ── */
.divisan-mobile-card {
  background-color: var(--d-cream);
  border-radius: 15px;
  border-left: 6px solid var(--d-green);
  cursor: pointer;
  transition: background 0.15s;
}
.divisan-mobile-card:active {
  background-color: rgba(96, 108, 56, 0.06);
}

/* Responsive */
@media (max-width: 768px) {
  .paginacion-wrapper {
    grid-template-columns: 1fr;
    justify-items: center;
  }
  .pag-izq {
    justify-content: center;
  }
  .contadores-inline {
    order: 2;
  }
  .pag-der {
    justify-self: center;
    order: 3;
  }
}
</style>
